import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './contact.css';
import emailjs from 'emailjs-com';  

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const emailParams = {
        from_name: formData.name,
        from_email: formData.email,  
        reply_to: formData.email,
        message: formData.message,
      };
      // 🔹 Send the emails with EmailJS
      emailjs.send( 
        'service_dvo0ueo',  
        'template_rfdj06h',
        emailParams,
        'aoPzy3tsZCEO-obVB'   
      )
      .then(() => {
        setSubmitted(true);
      })
      .catch((error) => {
        console.error('Eroare la trimiterea emailului:', error);
      });
    }
  };

  const validate = (data) => {
    const errors = {};
    if (!data.name) errors.name = 'Your name is necessary!';
    if (!data.email) errors.email = 'Your e-mail is necessary!';
    if (!data.message) errors.message = 'Your message is necessary!';
    return errors;
  };

  return (
    <div className='containerContact'>
      <div className='paragraphContact'>
        <h1 className='titleContact'>Hello. </h1>
        <span>Thank you for visiting my website. <br/>

          You can send me a message if you want/need to. <br/>Here is a form:
        </span>
      </div>
    
    <form onSubmit={handleSubmit} className="contact-form ">
      <div>
        <label>Nume:</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />
        {errors.name && <span className="error">{errors.name}</span>}
      </div>
      <div>
        <label>Email:</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
        {errors.email && <span className="error">{errors.email}</span>}
      </div>
      <div>
        <label>Mesaj:</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        {errors.message && <span className="error">{errors.message}</span>}
      </div>
      <button type="submit">Send</button>
      {submitted && <p className='sendContact'> The e-mail have been sent succesfully!</p>}
    </form>
    </div>
  );
}

export default Contact;